<template>
  <div class="screen-list-wrap">
    <iframe
      :src="src"
      frameborder="no"
      class="screen-iframe"
      scrolling="auto"
    />
  </div>
</template>

<script>
export default {
  name: 'ScreenList',
  data () {
    return {
      src: '/screen.html'
    }
  }
}
</script>

<style lang="less" scoped>
.screen-list-wrap {
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
}

.screen-iframe {
  width: 100%;
  height: 100%;
  min-height: 100%;
  border: none;
  display: block;
}
</style>
